<template>
  <div v-loading="loading">
    <el-table
      border
      :key="range.id"
      size="mini"
      :data="range.recommendations"
    >
      <el-table-column prop="name" label="Заголовок">
        <template v-slot="scope">
          <click-to-edit
            type="textarea"
            v-model="scope.row.name"
            :word-limit="1000"
            style="width: 100%"
            @input="updateRecommendation(scope.row)"
          ></click-to-edit>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Рекомендация">
        <template v-slot="scope">
          <click-to-edit
            type="textarea"
            v-model="scope.row.description"
            :word-limit="10000"
            style="width: 100%"
            @input="updateRecommendation(scope.row)"
          ></click-to-edit>
        </template>
      </el-table-column>

      <el-table-column width="45" align="right">
        <template v-slot="scope">
          <el-popconfirm
            style="float:left"
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            title="Вы уверены, что хотите удалить рекомендацию?"
            @confirm="deleteRecommendation(scope.row)"
          >
            <el-button
              slot="reference"
              class="table-action-button"
              size="mini"
              round
              icon="far fa-trash-alt"
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="text"
      size="mini"
      icon="fas fa-plus"
      @click="createRecommendation"
    >
      Создать рекомендацию
    </el-button>
  </div>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "recommendations-component",
  components: { ClickToEdit },
  props: {
    range: { type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    getRecommendations() {
      this.loading = true;
      this.$api.evaluation.recommendationSearch({
        range_id: this.range.id,
      })
        .then(({data}) => {
          this.$set(this.range, 'recommendations', data.recommendations);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    updateRecommendation(scope) {
      this.loading = true;
      this.$api.evaluation.recommendationUpdate({
        id: scope.id,
        name: scope.name ?? null,
        description: scope.description ?? null,
      })
        .then(data => {
          this.$notify.success({
            title: 'Обновлено',
            message: 'Рекомендация успешно обновлена'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    createRecommendation() {
      this.loading = true;
      this.$api.evaluation.recommendationCreate({
        range_id: this.range.id,
      })
        .then(data => {
          this.getRecommendations();
          this.$notify.success({
            title: 'Сохранено',
            message: 'Рекомендация успешно создана'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    deleteRecommendation(scope) {
      this.loading = true;
      this.$api.evaluation.recommendationDelete({
        ids: [scope.id],
      })
        .then(data => {
          this.getRecommendations();
          this.$notify.success({
            title: 'Удалено',
            message: 'Рекомендация успешно удалена'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
  }
}
</script>

<style>

</style>